<template>
  <div class="chat-window">
    <slot></slot>
    <div class="messages-container">
      <!-- <div class="message" v-for="message in messages" :key="message.index"> -->
      <div class="menu-user"
        style="position:absolute;"
        v-show="ContextMenu"
        :style="{top:ContextMenuTop,left:ContextMenuLeft}"
       ><!--  v-on:mouseleave="hideContextMenu" -->
         <menu-user :userinfo='senduser'></menu-user>
      </div>
      <div class="messages-list">
            <template v-for="(message, index) in messages" :key="index">
                <div  class="message" v-if="message.from !==`Admin`">
                    <user-name-tag
                    :user="message"
                    :displaymytalk="false"
                    :displayProfileImage="false"
                    :lineheight="true"
                    style="display:inline-block"
                    :msg="message.text"
                    />
                </div>
                <div class="adminMessage" v-else :class='`${message.color}`'>
                    {{message.text}}
                </div>
            </template>
      </div>
    </div>

    <div class="input-container">     
         <!-- 
          2021-06-15 방 입장 유저도 채팅 가능 하게 
          방장 매니져만 채팅 되는 코드
          :readonly="!isAuth || ( !isManager && !isOwner && chat_roomId !== 'm1'  && !chat_roomId.includes('mtm'))" -->
        <div class="wrap-input">
          <div class="input-area">
            <input
              type="text"
              v-model="msg"
              class="chatmsg"
              :placeholder="switchMode"
              :readonly="!isAuth"
              @keyup.enter="sendMessage()"
            />
          </div>
            <!-- :readonly="!isChat || !isAuth || ( !isManager && !isOwner && chat_roomId !== 'm1'  && !chat_roomId.includes('mtm'))" -->
          <div class="button-area">
            <button @click="sendMessage"
            :disabled="!msg">Send</button>
          </div>
        </div>
      
    </div>
  </div>
</template>

<script>
//import axios from "axios";
import MenuUser from "@/components/users/MenuUser.vue";

export default {
  name: "chatMain",
  props:[
      'chat_roomId',
      'messages',
      'admin_messages',
      'isChat',
      'ownerId',
      'ckstate',      
  ],
  components:{
    MenuUser
  },
   data() {
    return {
      msg: "",
      ContextMenu:false,
      x:0,
      y:0,
      ContextMenuTop:'300px',
      ContextMenuLeft:'',
      senduser:'',
    };
  },
  // watch:{
  //   isMessageDelete(state){
  //     if(state)
  //     {
  //       alert('메세지 초기화'); 
  //       this.initMessage();               
  //     }     
  //   }
  // },
  computed: {
    switchMode() {
        // if ( (this.isChat && this.isAuth && this.chat_roomId === 'm1') || this.isManager || this.isOwner || this.chat_roomId.includes('mtm'))
        if ( (this.isAuth && this.chat_roomId === 'm1') || this.isManager || this.isOwner)
        {
          return "메세지 입력하기";
        }else if(!this.isAuth){
            return "로그인이 필요합니다.";
        }else if(!this.isOwner && this.chat_roomId !== 'm1'){
            //return "채팅이 잠겨 있습니다.";
            return "메세지 입력하기";
        }else{
            return "다른곳에서 접속하셨습니다.";
        }
    },
    isAuth() {
      return this.$store.getters.isAuthenticated && this.$store.getters.currentUser.id !==0;
    },
    user() {
      return this.$store.getters.currentUser;
    },
    isOwner(){
      return this.user.id === this.ownerId && this.ownerId >0;
    },
    isManager(){
      if(this.$store.state.chat.roomInfo)
      {
        return this.$store.state.chat.roomInfo.roomInfo.manager.find((manager) => manager.user_id === this.user.id);
      }else{
        return false;
      }      
    },
    isMessageDelete(){
      return this.$store.state.sets.clearChatMessages;
    },
    isClear(){
      return this.chatclear;
    }

  },

  mounted() {
    //this.fetchMessages();

    // Listen to all clicks on the document 일단 다른 방식으로 처리 참고용으로 남겨둠
    document.addEventListener("click", function(event)
    {
      // 해당 클래스 네임을 클릭시는 팝업을 띄움
      if( event.target.classList !='username' && event.target.closest(".messages-container"))//messages-container 부모영역일때만 클릭시 하이드
      {
        //alert(event.target.classList);
        this.ContextMenu = false;
      }
    }.bind(this));

  },
  updated(){
    this.updateScroll();
  },
  methods: {
    
    hideContextMenu(){
      this.ContextMenu = false;
    },
    updateCoordinates: function(event){
      this.x = event.clientX;
      this.y = event.clientY;
    },
     dummy: function(event)
    {
        event.stopPropagation();
    },
    viewMenu(event,user){
      this.senduser =user;
      this.ContextMenuTop = (event.clientY-10)+'px';
      this.ContextMenuLeft = (event.clientX-10)+'px';
      this.ContextMenu = true;
    },
    // async fetchMessages() {
    //      this.isLoading = true;
    //     try {
    //          const response = await axios.get("/api/chat/fetchmessages",{
    //             params:{
    //               room_id:this.chat_roomId
    //             }
    //            })
    //           console.log(response);
    //           this.messages = response.data.reverse();
    //     }catch(error){
    //         console.log(error.response);
    //     }
    //     this.isLoading = false;

    // //   axios.get("/api/v1/chat/fetchmessages").then((response) => {
    // //     this.messages = response.data;
    // //     this.updateScroll();
    // //   });

    // },
    sendMessage() {
      if (!this.msg) {
        alert('메세지를 입력해 주세요')
        return;
      }
      if(!this.isChat)
      {
        //this.messages.push({from:'Admin', text:'다른곳에서 접속하셨습니다.새로고침 하시면 재접속됩니다.', color:'red'});
        console.log('2중접속된곳에서 채팅 시도');
        //return false;
      }
      //로그인 회원만 가능 하게
        if(!this.isAuth)
        {
            let result = confirm("로그인이 필요합니다.");
            if(result){
                //this.$router
                this.$router.push({ name: 'auth_login'});
                return;
            }else{
                return;
            }
        }
      //아래는 잘 작동
      //axios.post("/api/v1/chat/sendMessage",{user_id: this.$store.getters.currentUser.id,message:this.msg})

    //   if(this.isLoggedIn){
    //         this.$store.dispatch("chat/sendMessage", {user_id: this.userId, message:this.msg, room_id:this.chat_roomId});
    //         this.messages.push({
    //         user: this.$store.getters.currentUser,
    //         message: this.msg
    //     })
    //   }else{
    //       alert('로그인 필요')
    //   }
      this.$store.dispatch("refreshExpire");
      this.$emit('sendmessage', this.msg);
      this.msg = "";
      this.updateScroll()
    },
    updateScroll(){
        var objDiv = document.getElementsByClassName("messages-container")[0]
        objDiv.scrollTop = objDiv.scrollHeight
    },    
  },
};
</script>

<style lang="scss" scoped>
.chat-window {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  font-family: Dotum;
  border: 1px solid #dee3eb;
  border-left:none;
  .messages-container {
    flex: 1 1 auto;
    flex-basis: 0px;
    overflow-y:auto;
    .messages-list {
      font-size: 13px;
      letter-spacing: -1px;
        .adminMessage{
          background:#2943a3;
          color:#fff;
          margin: 3px 9px 3px 20px;
          line-height: 130%;
          text-overflow: ellipsis;
          word-break: break-all;
          padding: 3px 5px;
        }
        .message {
            padding: 5px 20px 5px 20px;
            line-height: 130%;
            text-overflow: ellipsis;
            word-break: break-all;
            &:last-of-type {
            border-bottom: none;
            }
        }
        .red{
            background:#c30;
        }



    }
  }
  .input-container {
    width: 100%;
    border-top: 1px solid #dee3eb;
    flex-basis: 50px;
    .wrap-input {
      display: flex;
      .input-area {
        flex: 1;
        input {
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding-left: 20px;
          font-size: 12px;
          font-family: Gulim, sans-serif;
          padding-right: 15%;
          border: none;
        }
      }
      .button-area {
        padding-top: 10px;
        width: 85px;
        padding-left: 5px;
        button {
          width: 75px;
          height: 35px;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
